import {css} from 'emotion'
import {Colors, Link} from './..'

export const EventStyle = (cover) => css({
  padding: '2rem',
  boxShadow: `0 0 20px 0 ${Colors.shadow}`,
  margin: '2rem 0px',
  position: 'relative',
  cursor: 'pointer',
  '.event': {
    '&-day': {
      maxWidth: 'calc(1/6 * 100%)',
      flexBasis: 'calc(1/6 * 100%)',
      textAlign: 'center',
      '.number': {
        fontSize: '3rem',
        color: Colors.red,
        fontWeight: 800,
      },
      '.day': {
        textTransform: 'uppercase',
        fontWeight: 800,
        color: Colors.red,
      },
      '.hour': {
        textTransform: 'uppercase',
        fontWeight: 800,
        color: Colors.grey,
      }
    },
    '&-info': {
      maxWidth: 'calc(4/6 * 100%)',
      flexBasis: 'calc(4/6 * 100%)',
    },
    '&-link': {
      maxWidth: 'calc(1/6 * 100%)',
      flexBasis: 'calc(1/6 * 100%)',
      alignSelf: 'center',
      textAlign: 'center',
      'span': {
        ...Link,
        color: Colors.grey,
        transition: 'color 200ms ease',
        '&:hover': {
          color: 'black',
        }
      }
    },
    '&-title': {
      textTransform: 'uppercase',
      fontWeight: 800,
      fontSize: '1.125rem',
    },
    '&-description, &-description p': {
      fontSize: '0.9375rem',
      lineHeight: '1.2rem',
      color: 'black'
    },
    '&-picture': {
      width: '100%',
      height: 460,
      background: `url(${cover}) no-repeat center`,
      backgroundSize: 'cover',
      margin: '2rem 0'
    },
  },
  '.close': {
    position: 'absolute',
    top: '2rem',
    right: '2rem',
    width: 20,
    height: 20,
    '&:before, &:after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transformOrigin: 'center center',
      width: 20,
      height: 1,
      background: 'black',
    },
    '&:before': {
      transform: 'translate(-50%, -50%) rotate(45deg)'
    },
    '&:after': {
      transform: 'translate(-50%, -50%) rotate(-45deg)'
    },
  }
})


// WEBPACK FOOTER //
// ./src/styles/components/event.js